// Vuex 때 처럼 create* 함수를 제공한다.
import { createWebHistory, createRouter } from 'vue-router';
import store from '@/vuex/index.js';

// import Vue from 'vue'
// import VueRouter from 'vue-router'
import StatViewManager from '@/views/map/StatViewManager.vue'
import StatView from '@/views/map/StatView.vue'
//import RegionBarChart from '@/views/map/RegionBarChart.vue'

import Home from '@/views/base/Home.vue'




import NewHome from '@/views/base/NewHome.vue'






import UserSignUp from '@/views/base/UserSignUp.vue'
import Login from '@/views/base/Login.vue'
import ReqMain from '@/views/requestscreen/ReqMain.vue'
import DiagnosisScreenList from '@/views/screen/DiagnosisScreenList.vue'
import DiagnosisScreenManageList from '@/views/screen/DiagnosisScreenManageList.vue'

import UserSignUpNotice from '@/views/base/UserSignUpNotice.vue'
import ReqManageMain from '@/views/requestscreen/ReqManageMain.vue'
import StatViewManagerHospitals from '@/views/map/StatViewManagerHospitals.vue';
import StatViewManagerPatients from '@/views/map/StatViewManagerPatients.vue';
import StatViewManagerAreaScreen from '@/views/map/StatViewManagerAreaScreen.vue';




// optStatView
import OptStatView from '@/views/_opt_stat/OptStatView.vue'
import OptStatViewManager from '@/views/_opt_stat/OptStatViewManager.vue'
import OptStatViewManagerHospitals from '@/views/_opt_stat/OptStatViewManagerHospitals.vue'
import OptStatViewManagerPatients from '@/views/_opt_stat/OptStatViewManagerPatients.vue'
import OptStatViewManagerAreaScreen from '@/views/_opt_stat/OptStatViewManagerAreaScreen.vue'

{/* <router-link to="/home" class="nav-link">Home</router-link>
            <router-link to="/request" class="nav-link">진단의뢰관리</router-link>
            <router-link to="/manage" class="nav-link">진단검사관리</router-link>
            <router-link to="/logout" class="nav-link" click="onLogout">Logout</router-link> */}
const routes = [
  {
    path: '/optstatviewmanager',
    name: 'OptStatViewManager',
    component: OptStatViewManager,
    meta:{requiresAuth:true}
  },
  {
    path: '/optstatviewmanager_hospitals',
    name: 'OptStatViewManagerHospitals',
    component: OptStatViewManagerHospitals,
    meta:{requiresAuth:true}
  },
  {
    path: '/optstatviewmanager_patients',
    name: 'OptStatViewManagerPatients',
    component: OptStatViewManagerPatients,
    meta:{requiresAuth:true}
  },
  {
    path: '/optstatviewmanager_areascreen',
    name: 'OptStatViewManagerAreaScreen',
    component: OptStatViewManagerAreaScreen,
    meta:{requiresAuth:true}
  },
  {
    path: '/optstatview',
    name: 'OptStatView',
    component: OptStatView,
    meta:{requiresAuth:false}
  },
  {
    path: '/statviewmanager_areascreen',
    name: 'StatViewManagerAreaScreen',
    component: StatViewManagerAreaScreen,
    meta:{requiresAuth:true}
  },
  {
    path:'/statviewmanager_patients',
    name: 'StatViewManagerPatients',
    component: StatViewManagerPatients,
    meta:{requiresAuth:true}
  },
  {
    path:'/statviewmanager_hospitals',
    name: 'StatViewManagerHospitals',
    component: StatViewManagerHospitals,
    meta:{requiresAuth:true}
  },
  {
    path:'/statviewmanager',
    name:'StatViewManager',
    component:StatViewManager,
    meta:{requiresAuth:true}
  },
  {
    path:'/statview',
    name:'StatView',
    component:StatView,
    meta:{requiresAuth:false}
  },
  // {
  //   path:'/barchart',
  //   name:'RegionBarChart',
  //   component:RegionBarChart, 
  //   meta:{requiresAuth:false}
  // },
  {
    path: '/',
    name: 'Root',
    component: Home, // 동적 import,
//    beforeEnter: requireAuth()
    meta:{requiresAuth:false}
  },
  {
    path: '/home',
    name: 'Home',
    component: Home, // 동적 import,
    meta:{requiresAuth:false}
  },
  {
    path: '/__newhome',
    name: 'NewHome',
    component: NewHome, // 동적 import,
//    beforeEnter: requireAuth()
    meta:{requiresAuth:true}
  },
  {
    path: '/request',
    name: 'ReqMain',
    component: ReqMain, // 동적 import,
    meta:{requiresAuth:true}
  },
  {
    path: '/request_manage',
    name: 'ReqManageMain',
    component: ReqManageMain, // 동적 import,
    meta:{requiresAuth:true}
  },
  {
    path: '/screen_list',
    name: 'DiagnosisScreenList',
    component: DiagnosisScreenList, // 동적 import,
    meta:{requiresAuth:true}
  },
  {
    path:'/screen_manage_list',
    name:'DiagnosisScreenManageList',
    component:DiagnosisScreenManageList,  
    meta:{requiresAuth:true}
  },
  {
    path: '/usersignup',
    name: 'UserSignUp',
    component: UserSignUp,      
    meta:{requiresAuth:false}
  },
  {
    path: '/usersignupnotice',
    name: 'UserSignUpNotice',
    component: UserSignUpNotice,  
    meta:{requiresAuth:false}
  },
  {
    path:'/login',
    name:'Login',
    component: Login,
    meta:{requiresAuth:false}
  },

];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 인증 상태 확인 함수
function isAuthenticated() {
  // localStorage에 jwt 토큰이 있는지 확인
  // 또는 Vuex store의 isLogin 상태를 확인할 수도 있습니다
  return !!localStorage.getItem('jwt');
}

// 라우터 가드: 인증이 필요한 페이지 접근 시 로그인 체크
router.beforeEach((to, from, next) => {
  const requiresAuth = to.meta.requiresAuth; // 이동하려는 라우트의 requiresAuth 값
  const loggedIn = isAuthenticated();        // API용 토큰 존재 (localStorage jwt)
  const sessionLoggedIn = store.getters['userStore/isLogin']; // UI·Vuex와 동일한 로그인 여부

  if (requiresAuth && !loggedIn) {
    // 1. 인증이 필요한 페이지인데, 로그인 상태가 아닐 경우
    console.log('로그인 필요: ' + to.path);
    // 로그인 페이지로 리다이렉트
    // 쿼리 파라미터로 원래 가려던 경로를 넘겨주면, 로그인 성공 후 해당 경로로 돌아갈 수 있습니다.
    next({
      name: 'Login', // 'Login'은 로그인 라우트의 name입니다.
      query: { redirect: to.fullPath }
    });
  } else if (to.name === 'Login' && sessionLoggedIn) {
    // 2. Vuex 기준으로 이미 로그인했는데 로그인 페이지로 가려고 할 경우 (MainHeader와 동일 기준)
    next({ name: 'Home' }); // 홈으로 리다이렉트
  } else {
    // 3. 정상적인 접근일 경우
    next();
  }
});

export default router;

